module.exports = __webpack_public_path__ + "img/blufi_cer.f042313b.png";